module.exports = __webpack_public_path__ + "static/kid1-6b3038dd6b35480e4e7bd75efb87406d.png";